import { apiClient } from '../client';
import { API_ENDPOINTS } from '../constant/endpoints';
import type { IApiResponse } from '../types';
import type { IOrganization } from '@/features/organization/interfaces/organization.interface';
import type {
    ICreateOrganizationDto,
    IUpdateOrganizationDto,
} from '@/features/organization/interfaces/organization.interface';

export const organizationApi = {
    getCurrent: () =>
        apiClient
            .get<IApiResponse<IOrganization>>(API_ENDPOINTS.ORGANIZATION.CURRENT)
            .then((r) => r.data.data),

    getAll: () =>
        apiClient
            .get<IApiResponse<IOrganization[]>>(API_ENDPOINTS.ORGANIZATION.ALL)
            .then((r) => r.data.data),

    create: (dto: ICreateOrganizationDto) =>
        apiClient
            .post<
                IApiResponse<{ organization: IOrganization; accessToken: string }>
            >(API_ENDPOINTS.ORGANIZATION.CURRENT, dto)
            .then((r) => r.data.data),

    update: (
        dto: IUpdateOrganizationDto,
        opts?: { logoFile?: File | null; removeLogo?: boolean },
    ) => {
        // Always send multipart with the DTO in a `dto` field. The backend
        // controller reads the body only via @Body('dto'), so a plain-JSON
        // PATCH arrives empty and silently drops the update (email/phone/website
        // never persist). The logo/removeLogo parts are optional.
        const form = new FormData();
        form.append('dto', JSON.stringify(dto));
        if (opts?.logoFile) form.append('logo', opts.logoFile);
        if (opts?.removeLogo) form.append('removeLogo', 'true');
        return apiClient
            .patch<IApiResponse<IOrganization>>(API_ENDPOINTS.ORGANIZATION.CURRENT, form, {
                headers: { 'Content-Type': 'multipart/form-data' },
            })
            .then((r) => r.data.data);
    },

    switch: (organizationId: string) =>
        apiClient
            .post<IApiResponse<{ accessToken: string }>>(API_ENDPOINTS.ORGANIZATION.SWITCH, {
                organizationId,
            })
            .then((r) => r.data.data),
};
